export const baseEndpoint = "/v1/opportunities";

export const opportunityConfigs = {
  create: {
    method: "POST",
    endpoint: `${baseEndpoint}`,
  },
  read: {
    method: "GET",
    endpoint: `${baseEndpoint}`,
    queryList: ["offset=0", "limit=10"],
  },
  get_by_id: {
    method: "GET",
    endpoint: `${baseEndpoint}`,
  },
  updateVisibility: {
    method: "PUT",
    endpoint: `${baseEndpoint}/$id/visibility`,
  },
  delete: {
    method: "DELETE",
    endpoint: `${baseEndpoint}/$id`,
  },
};
